// @ts-nocheck

import cancel from './bandeau_annule.png';
import win from './bandeau_gagne.png';
import lost from './bandeau_perdu.png';
import bonusWin from './combo_gagne.jpg';
import live from './en_cours.jpg';
import bonusLive from './en_cours_combo.jpg';

export default {
  RUNNING: {
    banner: live,
    bonus: bonusLive,
  },
  WINNING: {
    banner: win,
    bonus: bonusWin,
  },
  LOST: {
    banner: lost,
  },
  CANCELLED: {
    banner: cancel,
  },
  CASHOUT: {
    banner: win,
  },
};
